import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface TicketConversationDialogData {
  title: string;
  messages: any[];
}

@Component({
  selector: 'app-ticket-conversation-dialog',
  templateUrl: './ticket-conversation-dialog.component.html',
  styleUrls: ['./ticket-conversation-dialog.component.css']
})
export class TicketConversationDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<TicketConversationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TicketConversationDialogData,
  ) { }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
